import React, { useState } from 'react';
import { Guest } from '../../types/customer';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import TextField from '../TextField';

interface Props {
  guest?: Guest;
  index: number;
  mainCustomer: string;
  onSubmit: (guest: Guest) => void;
  onCancel: () => void;
  isLoading: boolean;
}

const PassengerForm: React.FC<Props> = ({
  index,
  guest,
  onSubmit,
  onCancel,
  mainCustomer,
  isLoading,
}) => {
  const { t } = useTranslation(['bookings', 'common']);

  const [firstName, setFirstName] = useState(guest?.FirstName || '');
  const [lastName, setLastName] = useState(guest?.Surname || '');
  const [email, setEmail] = useState(guest?.Email || '');
  const [mobile, setMobile] = useState(guest?.Mobile || '');
  const [over18, setOver18] = useState(!!guest);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      FirstName: firstName,
      Surname: lastName,
      Email: email,
      Mobile: mobile,
      MainCustomer: mainCustomer,
    });
  };

  const handleInvalid = (e: React.InvalidEvent<HTMLInputElement>) => {
    e.target.setCustomValidity(
      t('You must confirm that the passenger is over 18.')
    );
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOver18(e.target.checked);
    e.target.setCustomValidity('');
  };

  return (
    <form onSubmit={handleSubmit} className='relative w-full'>
      <div className={`mb-4 w-full flex flex-wrap pb-4 `}>
        <div className='w-full'>
          <label className='font-rukaNeue text-xl block mb-2'>
            {`${t('Traveler')} ${(index = index === 0 ? 1 : index)}`}
          </label>
        </div>

        <div className='w-full flex items-center py-4'>
          <input
            className='w-6 h-6 border border-gray-300 text-sm rounded-lg block p-2.5'
            type='checkbox'
            checked={over18}
            tabIndex={1}
            onChange={handleCheckboxChange}
            required={true}
            onInvalid={handleInvalid}
          />
          <label className='ml-2 text-sm'>{t('Over18')}</label>
        </div>

        <div className='w-full grid grid-cols-1 gap-y-6 md:grid-cols-2 md:gap-x-9'>
          <TextField
            id='first_name'
            label={t('FirstName')}
            value={firstName}
            onChange={setFirstName}
            disabled={!over18}
            required={true}
          />
          <TextField
            id='last_name'
            label={t('LastName')}
            value={lastName}
            onChange={setLastName}
            disabled={!over18}
            required={true}
          />
          <TextField
            id='email'
            label={t('Email')}
            type='email'
            value={email}
            onChange={setEmail}
            disabled={!over18 || !!(guest && guest.Email)}
            required={true}
          />
          <TextField
            id='mobile'
            label={t('Mobile')}
            type='tel'
            validation='tel'
            value={mobile}
            onChange={setMobile}
            disabled={!over18}
            required={true}
          />
        </div>

        <div className='w-full pt-4 flex items-end md:justify-end'>
          <Button type='submit' className='mr-3' disabled={isLoading}>
            {t('Submit')}
          </Button>
          <Button
            className='text-black border border-black'
            variant='transparent'
            onClick={onCancel}
          >
            {t('Cancel')}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default PassengerForm;
